// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"116":"d9d7201d","416":"446481b8","525":"0a5cc0c8","642":"76c42009","675":"89cb9c53","884":"6358bad7"}[chunkId] + ".chunk.js";
};